export const faqs = [
  {
    q: 'How will I receive Calm Response 5™?',
    a: "Immediately after your purchase, you'll receive instructions to access and download the digital materials included in the program.",
  },
  {
    q: 'Is this only for children with autism?',
    a: 'No. I designed the system for parents and caregivers of neurodivergent children, including children with autism, ADHD and sensory sensitivities. Every child is different, so I encourage you to adapt the tools to your child’s individual needs.',
  },
  {
    q: 'Is this a treatment for autism or ADHD?',
    a: 'No. I created Calm Response 5™ as an educational and practical resource to help caregivers respond to difficult moments with greater structure and predictability. It does not diagnose, treat or cure autism, ADHD or any other medical condition.',
  },
  {
    q: 'Do I need previous experience?',
    a: "No. I created the system so that you can start even if you've never used a structured response framework before.",
  },
  {
    q: 'Do I need to buy anything else?',
    a: "No. You don't need to purchase oils, supplements, devices or other products to use the core system.",
  },
  {
    q: "Will Calm Response 5™ stop my child's meltdowns?",
    a: 'I would never promise you that. Every child is different, and meltdowns can have many different contributing factors. What I can give you is a clear framework for recognizing patterns, organizing your response and feeling more prepared when difficult moments happen.',
  },
  {
    q: 'Can I use this alongside professional support?',
    a: 'Yes. You can use the observation tools and Personal Calm Plan™ to organize information that you may wish to discuss with qualified healthcare, educational or behavioral professionals.',
  },
  {
    q: 'Is this a one-time payment?',
    a: "Yes. You'll pay $27 once. There are no required monthly payments. The price is shown in USD and is converted to your local currency automatically at checkout.",
  },
  {
    q: 'Can I download the materials?',
    a: 'Yes. The included resources are delivered digitally and can be downloaded for personal use.',
  },
  {
    q: "What if I don't like it?",
    a: 'You have a 7-day guarantee according to the purchase terms.',
  },
];
